import React from 'react';

import Airline from './air/Airline';
import Airport from './air/Airport';

import OriginalBlType from './ocean/OriginalBlType';
import ContainerType from './ocean/ContainerType';
import MoveType from './ocean/MoveType';
import ScheduleDkPort from './ocean/ScheduleDkPort';
import VesselName from './ocean/VesselName';

import OtherShipmentType from './OtherShipmentType';

import ExportInfo from './aes/ExportInfo';
import LicenseInfo from './aes/LicenseInfo';
import Scheduleb from './aes/Scheduleb';
import Carrier from './aes/Carrier';
import BuyingRate from './aes/BuyingRate';

import AnTitle from './AnTitle';

import CurrencyCode from './currency/CurrencyCode';
import ExchangeRate from './ExchangeRate';
// import ExchangeRate from './currency/ExchangeRate';

import Country from './region/Country';
import State from './region/State';
import UnLocationCode from './region/UnLocationCode';

import Edi315 from './Edi315';

import MemoTitle from '../../myTask/memoInfo/MemoTitle';

function CodesFactory({ componentIndex, carrierBuyRate, setCarrierBuyRate, setHideTab}) {
  
  if (componentIndex === 0) {
    return <OriginalBlType />;
  }
  else if (componentIndex === 1) {
    return <ContainerType />;
  }
  else if (componentIndex === 2) {
    return <MoveType />;
  }
  else if (componentIndex === 3) {
    return <ScheduleDkPort componentIndex={componentIndex} />;
  }
  else if (componentIndex === 4) {
    return <VesselName componentIndex={componentIndex} />;
  }
  else if (componentIndex === 5) {
    return <Airline componentIndex={componentIndex}/>;
  }
  else if (componentIndex === 6) {
    return <Airport componentIndex={componentIndex} />;
  }
  else if (componentIndex === 7) {
    return <OtherShipmentType />;
  }
  else if (componentIndex === 8) {
    return <ExportInfo />;
  }
  else if (componentIndex === 9) {
    return <LicenseInfo />;
  }
  else if (componentIndex === 10) {
    return <Scheduleb />;
  }
  else if (componentIndex === 11) {
    return <Carrier componentIndex={componentIndex} carrierBuyRate={carrierBuyRate} setCarrierBuyRate={setCarrierBuyRate} setHideTab={setHideTab}/>;
  }
  else if(componentIndex === 12){
    return <BuyingRate carrierBuyRate={carrierBuyRate} componentIndex={componentIndex} />;
  }
  else if (componentIndex === 13) {
    return <AnTitle />;
  }
  // else if (componentIndex === 14) {
  //   return <CommodityCode />;
  // }
  else if (componentIndex === 15) {
    return <CurrencyCode componentIndex={componentIndex} />;
  }
  else if (componentIndex === 16) {
    return <ExchangeRate componentIndex={componentIndex} />;
  }
  else if (componentIndex === 17) {
     return <MemoTitle />;
  }
  // else if (componentIndex === 13) {
  //   return <ExchangeRate />;
  // }
  else if (componentIndex === 19) {
    return <Country componentIndex={componentIndex} />;
  }
  else if (componentIndex === 20) {
    return <State componentIndex={componentIndex} />;
  }
  else if (componentIndex === 21) {
    return <UnLocationCode componentIndex={componentIndex} />;
  }
  else if (componentIndex === 22) {
    return <Edi315 />;
  }

  return (
    <div>
    </div>
  );
}

export default CodesFactory;
